import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private errorSUbject = new BehaviorSubject<string>('');
  errorMessage$ = this.errorSUbject.asObservable();

  constructor() {}

  setError(message: string) {
    this.errorSUbject.next(message);
  }

  clearError() {
    this.errorSUbject.next('');
  }
}
